import { FC } from 'react';
import clsx from 'clsx';

type Props = {
  steps: {
    label: string;
    step: number;
  }[];
  activeStep: number;
};

const StepsHeader: FC<Props> = ({ steps, activeStep }) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
      {steps.map((step, index) => (
        <div key={index} className="tw-w-full tw-select-none tw-outline-0">
          <div
            className={clsx('tw-h-2 tw-rounded tw-bg-grayscale-20', {
              'tw-bg-success-100': step.step === activeStep,
            })}
          />
          <div
            className="tw-mt-2 tw-flex tw-items-center tw-text-md"
            data-cy={`step-header-${step.step}`}
          >
            <span className="tw-mr-2 tw-font-medium">Step {step.step}</span>
            <span
              className={clsx('tw-font-regular tw-text-grayscale-70', {
                'tw-text-success-100': step.step === activeStep,
              })}
            >
              {step.label}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StepsHeader;
